export default class BrandingImagesModel {
  public mainLogo: string = null;
  public mobileLogo: string = null;
  public backgroundImage: string = null;
  public mobileBackgroundImage: string = null;
  public additionalImage: string = null;
}
